import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"play\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M250 475C374.264 475 475 374.264 475 250C475 125.736 374.264 25 250 25C125.736 25 25 125.736 25 250C25 374.264 125.736 475 250 475ZM312.143 252.6C314.147 251.444 314.147 248.553 312.143 247.397L229.111 199.458C227.109 198.302 224.605 199.747 224.605 202.06V297.937C224.605 300.25 227.109 301.695 229.111 300.539L312.143 252.6Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol